import {
	Layout,
	Breakpoints,
	Container,
	ContainerPadding,
	ContainerGutter,
	TokenTextAppearance,
	TokenTextColor,
	TextAlignment,
	Text,
} from '@volkswagen-onehub/components-core';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { HuchaCard } from './hucha/components/card/hucha-card';
import { PortalContext } from '../../context/portal-context';
import { useHuchaValues } from './hucha/hooks/use-hucha-values';
import { COLOR_TOKEN } from '../../helpers/color-tokens';
import { PersonBenefits } from '@esportal/portal-service';
import { Vouchers } from './vouchers/vouchers';

const Background = styled.div`
	background: ${COLOR_TOKEN.background.highlight};
`;

export const Benefits: React.FC<{
	personBenefits: PersonBenefits;
}> = ({ personBenefits }) => {
	const { portalService } = React.useContext(PortalContext);
	const sectionRef = useRef<HTMLElement>(null);
	const userData = portalService?.getPerson()?.getValue();
	const huchaValues = useHuchaValues(userData, personBenefits);
	const vouchersRef = React.useRef<HTMLDivElement | null>(null);

	return (
		<Background>
			<section ref={sectionRef}>
				<Container
					data-testid="benefits-container"
					padding={{
						top: {
							[Breakpoints.default]: ContainerPadding.dynamic0250,
							[Breakpoints.b560]: ContainerPadding.dynamic0150,
						},
						bottom: {
							[Breakpoints.default]: ContainerPadding.dynamic0300,
							[Breakpoints.b560]: ContainerPadding.dynamic0250,
						},
					}}
					wrap="always"
					gutter={ContainerGutter.dynamic0100}
				>
					<Layout
						data-testid="benefits-layout"
						appearance={{
							[Breakpoints.default]: [
								{ name: '.', columns: 1 },
								{ name: 'benefits-section', columns: 22 },
								{ name: '.', columns: 1 },
							],
						}}
					>
						<Container data-testid="benefits-container" gutter={ContainerGutter.dynamic0100} wrap="always">
							<Container data-testid="top-text" wrap={'always'}>
								<Text
									appearance={TokenTextAppearance.bigcopy200}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
									bold
								>
									Beneficios
								</Text>
								<Text
									appearance={TokenTextAppearance.headline500}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
								>
									Para ti, por <b>ser del club</b>
								</Text>
							</Container>
						</Container>
					</Layout>

					<Layout
						data-testid="vouchers-layout"
						appearance={{
							[Breakpoints.default]: [{ name: 'vouchers-section', columns: 24 }],
						}}
					>
						<Vouchers userData={userData} personBenefits={personBenefits} vouchersRef={vouchersRef} />
					</Layout>

					<Layout
						data-testid="hucha-layout"
						appearance={{
							[Breakpoints.default]: [
								{ name: '.', columns: 1 },
								{ name: 'hucha-section', columns: 22 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1920]: [
								{ name: '.', columns: 3 },
								{ name: 'hucha-section', columns: 18 },
								{ name: '.', columns: 3 },
							],
							[Breakpoints.b2560]: [
								{ name: '.', columns: 5 },
								{ name: 'hucha-section', columns: 14 },
								{ name: '.', columns: 5 },
							],
						}}
					>
						<Container data-testid="hucha-container" gutter={ContainerGutter.dynamic0100} wrap="always">
							<Text
								appearance={TokenTextAppearance.headline400}
								color={TokenTextColor.primary}
								textAlign={TextAlignment.left}
							>
								<b>Ahorro acumulado</b> para tu próximo Volkswagen
							</Text>
							<HuchaCard huchaValues={huchaValues} />
						</Container>
					</Layout>
				</Container>
			</section>
		</Background>
	);
};
